import React from 'react';
import { remCss } from 'src/helpers';

const NotificationApprovedIcon = React.memo(({ width = 60, viewBox = '0 0 60 60' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(width)}
    viewBox={viewBox}
  >
    <g id='Group_3154' data-name='Group 3154' transform='translate(-825 -406)'>
      <g
        id='Ellipse_148'
        data-name='Ellipse 148'
        transform='translate(825 406)'
        fill='#fff'
        stroke='rgba(112,112,112,0.2)'
        strokeWidth='1'
      >
        <circle cx='30' cy='30' r='30' stroke='none' />
        <circle cx='30' cy='30' r='29.5' fill='none' />
      </g>
      <g id='_1251194' data-name='1251194' transform='translate(840.5 421)'>
        <path
          id='Path_10732'
          data-name='Path 10732'
          d='M22.536,113.2v9.574l-.006.033a5.747,5.747,0,0,0-.672-.033,6.524,6.524,0,0,0-6.522,6.522,6.417,6.417,0,0,0,.3,1.95l-.013.007H3.109A2.608,2.608,0,0,1,.5,128.642V113.2Zm0,0'
          transform='translate(0 -105.817)'
          fill='#6c7293'
        />
        <path
          id='Path_10733'
          data-name='Path 10733'
          d='M16.608,39h3.326a2.608,2.608,0,0,1,2.609,2.609v2.23H.5v-2.23A2.608,2.608,0,0,1,3.109,39Zm0,0'
          transform='translate(0 -36.457)'
          fill='#d2d4de'
        />
        <path
          id='Path_10734'
          data-name='Path 10734'
          d='M11.867,113.2H.5v15.443a2.608,2.608,0,0,0,2.609,2.609h8.759Zm0,0'
          transform='translate(0 -105.817)'
          fill='#d2d4de'
        />
        <path
          id='Path_10735'
          data-name='Path 10735'
          d='M11.867,39.1H3.109A2.608,2.608,0,0,0,.5,41.71v2.23H11.861V39.1Zm0,0'
          transform='translate(0 -36.552)'
          fill='#6c7293'
        />
        <path
          id='Path_10736'
          data-name='Path 10736'
          d='M235.294,260.033a6.523,6.523,0,1,1-6.893,8.439,6.416,6.416,0,0,1-.3-1.95A6.524,6.524,0,0,1,234.622,260c.228,0,.45.013.672.033Zm0,0'
          transform='translate(-212.757 -243.044)'
          fill='#d2d4de'
        />
        <path
          id='Path_10737'
          data-name='Path 10737'
          d='M270.292,326.865a.668.668,0,0,1-.463-.189l-2.459-2.459a.65.65,0,0,1,.919-.919l2.009,2.008,3.874-3.7a.65.65,0,0,1,.9.939l-4.33,4.135a.632.632,0,0,1-.45.183Zm0,0'
          transform='translate(-249.289 -300.466)'
          fill='#fff'
        />
        <g id='Group_3153' data-name='Group 3153' transform='translate(5.163)'>
          <path
            id='Path_10738'
            data-name='Path 10738'
            d='M82.761,209.1H72.652a.652.652,0,0,0,0,1.3H82.761a.652.652,0,1,0,0-1.3Zm0,0'
            transform='translate(-72 -195.465)'
            fill='#fff'
          />
          <path
            id='Path_10739'
            data-name='Path 10739'
            d='M78.7,274.1H72.652a.652.652,0,1,0,0,1.3H78.7a.652.652,0,1,0,0-1.3Zm0,0'
            transform='translate(-72 -256.226)'
            fill='#fff'
          />
          <path
            id='Path_10740'
            data-name='Path 10740'
            d='M82.152,5.093a.654.654,0,0,0,.652-.652V.652a.652.652,0,0,0-1.3,0V4.441A.654.654,0,0,0,82.152,5.093Zm0,0'
            transform='translate(-80.88)'
            fill='#6c7293'
          />
          <path
            id='Path_10741'
            data-name='Path 10741'
            d='M238.152,0a.654.654,0,0,0-.652.652V4.441a.652.652,0,0,0,1.3,0V.652A.654.654,0,0,0,238.152,0Zm0,0'
            transform='translate(-226.707)'
            fill='#6c7293'
          />
        </g>
      </g>
    </g>
  </svg>
));
NotificationApprovedIcon.displayName = 'NotificationApprovedIcon';

export default NotificationApprovedIcon;
